import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $(this.element).on("focusout", function () {
      this.value = this.value?.toLocaleUpperCase();
    });
  }
}
